import React from 'react'

export const QuestionMark = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="https://www.w3.org/2000/svg">
    <path
      d="M5.254 5.2C5.39506 4.799 5.67349 4.46086 6.03997 4.24548C6.40645 4.0301 6.83734 3.95136 7.25631 4.02323C7.67527 4.09509 8.05529 4.31291 8.32905 4.63812C8.6028 4.96332 8.75263 5.37491 8.752 5.8C8.752 7 6.952 7.6 6.952 7.6M7 10H7.006M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
      stroke="#8B8888"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
